import { filter, tap } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';
import * as fromSession from '../../core/reducers/session.reducer';
import { UserService } from 'src/app/shared/services/user.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'timesheet',
  templateUrl: './timesheet.component.html',
  styleUrls: ['./timesheet.component.scss']
})
export class TimesheetComponent implements OnInit {

  form: FormGroup;
  exps = [];
  types = [];
  tarifs = [];
  months = [
    { value: 1, name: 'Janvier' },
    { value: 2, name: 'Février' },
    { value: 3, name: 'Mars' },
    { value: 4, name: 'Avril' },
    { value: 5, name: 'Mai' },
    { value: 6, name: 'Juin' },
    { value: 7, name: 'Juillet' },
    { value: 8, name: 'Août' },
    { value: 9, name: 'Septembre' },
    { value: 10, name: 'Octobre' },
    { value: 11, name: 'Novembre' },
    { value: 12, name: 'Décembre' }
  ];

  constructor(
    private _fb: FormBuilder,
     private store: Store<any>,
      private userService: UserService,
      private httpClient: HttpClient

  ) {



    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();
    this.form = this._fb.group({
      month: [currentMonth, [Validators.required]],
      year: [currentYear, [Validators.required]],
      user: [null, [Validators.required]]
    });

    this.httpClient.get('https://api.comelex.jklm.be/v1/type-prestations').subscribe((t: any[]) => {

      this.types = t.map(x => ({...x, total: 0}));
      this.httpClient.get('https://api.comelex.jklm.be/v1/tarif-codes').subscribe((t2: any[]) => {
      this.tarifs = t2.map(x => ({...x, total: 0}));

    this.form.valueChanges.subscribe(t => {
      if (this.form.valid) {
        this.types = this.types.map(x => ({...x, total: 0}));
        this.tarifs = this.tarifs.map(x => ({...x, total: 0}));
        this.httpClient.get(environment.apiRul + "/v1/prestations/timesheet?month="+ this.form.value.month +"&year="+ this.form.value.year +"&userId=" + this.form.value.user.id + "&expand=expertisel,type")
        .subscribe((t: any) => {

          // group by expertisel.id
          this.exps = t.reduce((r, a) => {
            r[a.expertisel.id] = r[a.expertisel.id] || {
              expertisel: a.expertisel,
              prestations: [],
              unit: {}
            };
            r[a.expertisel.id].prestations.push(a);
            if (!r[a.expertisel.id]['unit'][a.type.id]) {
              r[a.expertisel.id]['unit'][a.type.id] = 0;
            }
            r[a.expertisel.id]['unit'][a.type.id] += parseFloat(a.quantity);

            let aa = this.types.find(x => x.id === a.type.id);
            if (aa) {
              aa.total += parseFloat(a.quantity);
            }
            let aa2 = this.tarifs.find(x => x.id === a.type.unit);
            if (aa2) {
              aa2.total += parseFloat(a.quantity);
            }
            return r;
          }, Object.create(null));
          console.log(this.exps);
          console.log(this.types);

        });
      }
    });

  });

    this.store.select(fromSession.selectSession).subscribe(session => {
      userService.getAll('name',2,{},0,20).subscribe(t => {
         const x = t.body.filter(u => u.email === session.email);
         this.form.controls.user.setValue(x[0]);
     } );
   });
  });



  }

  ngOnInit() {
  }

}
